import { createSelector } from '@reduxjs/toolkit';
import { selectHouseAddress } from './selectHouseAddress';

export const selectHouseFullAddress = createSelector(selectHouseAddress, address =>
  address.map(a => a.name).join(', '),
);
